import { Home, Paintbrush, Search, ShoppingCart } from 'lucide-react';
import { useTheme } from "../hooks/useTheme.jsx";
import { ImageWrapper } from './ImageWrapper.jsx';
import { motion, AnimatePresence } from 'motion/react';
import defaultLogo from "../images/defaultLogo.svg";

export function Header({ showThemeChanger, showSearchView, cartCount, showHome = true, onHomeClick, onSearchClick, onCartClick, onLogoClick, logActivity, style }) {
  const {theme, setTheme} = useTheme();
  const imgLogo = theme === 'dark' ? (style?.global?.secondaryClientLogo || style?.global?.mainClientLogo || defaultLogo) : (style?.global?.mainClientLogo || style?.global?.secondaryClientLogo || defaultLogo)
  const clientName = style?.global?.clientName || "Logo Cliente";

  const handleLogoClick = () => {
    if (onLogoClick) onLogoClick();
  };

  const handlGoToHomeClick = () => {
    logActivity('header', 'home-button', 'click', true, null);
    onHomeClick();
  };

  const handleThemeChangeClick = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    logActivity('header', 'theme-button', 'click', true, {new_theme: newTheme});
    setTheme(newTheme);
  };

  const handleGoToSearchClick = () => {
    logActivity('header', 'search-button', 'click', true, null);
    onSearchClick();
  };

  const handleGoToCartClick = () => {
    logActivity('header', 'cart-button', 'click', true, null);
    onCartClick();
  };

  return (
    <header className="sticky top-0 z-50 shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] w-full h-[112px]">
      <div className="flex items-center justify-between px-6 py-4 max-w-screen-xl mx-auto">
        <div className="flex gap-2">
          {showHome ? (
            <motion.button
                onClick={handlGoToHomeClick}
                className="flex items-center justify-center w-14 h-14 rounded-full transition-colors cursor-pointer"
                aria-label="Inicio"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.5 }}
              >
              <Home className="w-10 h-10" style={{ strokeWidth: 2 }} />
            </motion.button>
          ) : null}
          {showThemeChanger ? (
            <motion.button
              onClick={handleThemeChangeClick}
              className="flex items-center justify-center w-14 h-14 rounded-full transition-colors cursor-pointer"
              aria-label="Cambiar tema"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.5 }}
            >
              <Paintbrush className="w-10 h-10" style={{ strokeWidth: 2 }} />
            </motion.button>
          ) : null}
          {!showHome && (
            <div className='w-10 h-10'></div>
          )}
          {!showThemeChanger && (
            <div className='w-10 h-10'></div>
          )}
        </div>
        <div className="img-logo flex-1 flex justify-center cursor-pointer w-auto h-20" onClick={handleLogoClick}>
          <ImageWrapper
            image={imgLogo}
            alt={clientName}
            display="block"
            mode="contain"
            width="100%"
            height="100%"
            backgroundColor="transparent"
            margin="0"
            padding="0"
            borderRadius="0"
            transition={true}
            loadDelay={0.1}
            onLoad={undefined}
          />
        </div>
        <div className="flex gap-2">
          {!showSearchView && (
            <div className='w-10 h-10'></div>
          )}
          {showSearchView ? (
            <motion.button
              onClick={handleGoToSearchClick}
              className="flex items-center justify-center w-13 h-13 rounded-full transition-colors cursor-pointer"
              aria-label="Buscar"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.5 }}
            >
              <Search className="w-10 h-10" style={{ strokeWidth: 2 }} />
            </motion.button>
          ) : null}
          <motion.button
            onClick={handleGoToCartClick}
            className="relative flex items-center justify-center w-13 h-13 rounded-full transition-colors cursor-pointer"
            aria-label="Carrito de compras"
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.5 }}
          >
            <ShoppingCart className="w-10 h-10" style={{ strokeWidth: 2 }} />
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-(--color-primary) text-(--color-primary-label) rounded-full w-6 h-6 flex items-center justify-center text-xs">
                {cartCount}
              </span>
            )}
          </motion.button>
        </div>
      </div>
    </header>
  );
}
